import { horizontalRelationships, verticalRelationships } from '../config/constants';
import type { FamilyTreeEdgeType, FamilyTreeNode } from '../interfaces';
import { NodeHandlerId } from '../types/node-handler-id';

export const isHorizontalEdge = (edge?: FamilyTreeEdgeType) => !!edge && horizontalRelationships.includes(edge.data!.relationshipType);

export const isVerticalEdge = (edge?: FamilyTreeEdgeType) => !!edge && verticalRelationships.includes(edge.data!.relationshipType);

export const isNodeIdInEdge = (nodeId: string) => (edge: FamilyTreeEdgeType) => [edge.source, edge.target].includes(nodeId);

export const isVisibleEdge = (visibleNodes: FamilyTreeNode[]) => (edge: FamilyTreeEdgeType) =>
    visibleNodes.some((n) => [edge.target, edge.source].includes(n.id));

interface IEdgeHandlesResult {
    sourceHandle: NodeHandlerId;
    targetHandle: NodeHandlerId;
}

export const getEdgeHandles = (edge: FamilyTreeEdgeType, nodes: FamilyTreeNode[]): IEdgeHandlesResult => {
    const sourceNode = nodes.find((node) => node.id === edge.source)!;
    const targetNode = nodes.find((node) => node.id === edge.target)!;

    if (isHorizontalEdge(edge)) {
        const isSourceLeft = sourceNode.position.x < targetNode.position.x;

        return isSourceLeft
            ? { sourceHandle: NodeHandlerId.SOURCE_RIGHT, targetHandle: NodeHandlerId.TARGET_LEFT }
            : { sourceHandle: NodeHandlerId.SOURCE_LEFT, targetHandle: NodeHandlerId.TARGET_RIGHT };
    } else {
        const isSourceTop = sourceNode.position.y > targetNode.position.y;

        return isSourceTop
            ? { sourceHandle: NodeHandlerId.SOURCE_TOP, targetHandle: NodeHandlerId.TARGET_BOTTOM }
            : { sourceHandle: NodeHandlerId.SOURCE_BOTTOM, targetHandle: NodeHandlerId.TARGET_TOP };
    }
};
